import thumbnail from '../../../../images/report_thumbnail_agency.png';
import { ReportV2Dto } from '../../../api';
import { DatasetSlugs } from '../../dataset';

const dimensionsWithDescriptions = [
    {
        key: 'number_of_agencies',
        title: 'Number of marketing agencies your company currently works with',
        description: null,
    },
    {
        key: 'agency_compensation',
        title: 'Total annual compensation for marketing agencies',
        description: null,
    },
    {
        key: 'compensation_structure',
        title: 'Structure of your agency compensation',
        description: null,
    },
    {
        key: 'satisfaction_rating',
        title: 'Satisfaction with your marketing agencies',
        description: null,
    },
];

export const AgencyCompensationReport: ReportV2Dto = {
    id: 'agency_compensation',
    name: 'Agency Compensation',
    tagline: null,
    description: `Understand if you are paying a fair price for your agency relative to parameters of your company such as spend or revenue (obtained from Varos integrations)`,
    category: 'marketing',
    dataset: DatasetSlugs.AGENCY_COMP,
    traits: [],
    tags: ['strategy', 'trends'],
    dependencies: [
        {
            kind: 'survey',
            dataset: DatasetSlugs.AGENCY_COMP,
        },
    ],
    thumbnail: {
        description: null,
        url: thumbnail,
    },
    images: [
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
    ],
    visualizations: dimensionsWithDescriptions.map((dimension) => ({
        key: dimension.key,
        kind: 'bar',
        name: dimension.title,
        description: dimension.description,
        aggregation: 'count',
        breakdown: {
            keys: [dimension.key],
        },
    })),
};
